import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const createAccount = customer => {
  const {
    id: customerId,
    name: customerName,
    packageName: customerTier,
    salesforceId
  } = customer;
  return {
    id: customerId,
    customer_name: customerName,
    customer_tier: customerTier,
    salesforce_id: salesforceId
  };
};

const createVisitor = (user, userProfile) => {
  const { id: userId, firstName, lastName, included } = user;

  const roles = included
    ?.filter(
      ({ type, attributes }) => type === "role" && attributes.assignableInPhq
    )
    .map(({ attributes }) => attributes.name);

  return {
    id: userId,
    user_name: `${firstName} ${lastName}`,
    position: userProfile.position,
    roles
  };
};

export const usePendo = () => {
  const [initialized, setInitialized] = useState(false);

  const { user, loading: isUserLoading } = useSelector(
    ({ userState }) => userState
  );
  const { customer, loading: isCustomerLoading } = useSelector(
    ({ customerState }) => customerState
  );

  const { userProfile, loading: isProfileLoading } = useSelector(
    ({ userProfileState }) => userProfileState
  );

  useEffect(() => {
    if (
      !initialized &&
      user &&
      customer &&
      userProfile &&
      !isUserLoading &&
      !isCustomerLoading &&
      !isProfileLoading
    ) {
      const pendo = window.pendo;
      const instance = {
        visitor: createVisitor(user, userProfile),
        account: createAccount(customer)
      };
      pendo.initialize(instance);

      setInitialized(true);
    }
  }, [
    initialized,
    customer,
    user,
    isUserLoading,
    isCustomerLoading,
    isProfileLoading,
    userProfile
  ]);

  useEffect(() => {
    if (
      initialized &&
      customer &&
      user &&
      userProfile &&
      !isUserLoading &&
      !isCustomerLoading &&
      !isProfileLoading
    ) {
      const pendo = window.pendo;
      const instance = {
        visitor: createVisitor(user, userProfile),
        account: createAccount(customer)
      };
      pendo.updateOptions(instance);
    }
  }, [
    initialized,
    customer,
    user,
    isUserLoading,
    isCustomerLoading,
    isProfileLoading,
    userProfile
  ]);
};
